module.exports = __webpack_public_path__ + "static/media/dropdown-down-white.6a182e48.svg";